import React from 'react'
import { Calendar } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import moment from 'moment'
import DatePicker from 'react-date-picker';
import './addon.css'

export class CI2 extends React.Component {

  constructor(props) {
    super(props);
    this.onDateChange = this.onDateChange.bind(this)
    let date = new Date()
    this.state = {
      date : date,
    }
  }

  onDateChange(date) {
    if(typeof this.props.applyDate !== "undefined") {
        date = moment(date).format()
        this.props.applyDate(date)
    }
  }

  render() {
    let date = new Date()
    if(this.props.date !== "undefined" && this.props.date !== null && this.props.date !== "") {
      date = new Date(this.props.date)
    }

   return (
     <div>
       <DatePicker clearIcon={null} style={{border:"1px solid #ddd"}} calendarIcon={null}
         onChange={this.onDateChange}
         value={date}
       />
     </div>
   );
 }
}



export default class CI extends React.Component {


  constructor(props) {
    super(props);

    this.onDateChange = this.onDateChange.bind(this)
    this.toggleDate = this.toggleDate.bind(this)
    this.applyDate = this.applyDate.bind(this)
    this.dateDisplayFormat = this.dateDisplayFormat.bind(this)
    let date = new Date()
    this.state = {
      showDateSelection: false,
      date : date,
      displayDate: this.dateDisplayFormat(date),
    };
  }


  dateDisplayFormat(date) {

    let d_date = date.getDate()+" "+ moment(date).format('MMM')+" "+date.getFullYear()
    return d_date;
  }

  onDateChange(date) {
    console.log(date);
    this.setState({date: date, displayDate: this.dateDisplayFormat(date)})
    this.props.applyDate(date)
    this.toggleDate()
  }

  applyDate() {
    this.props.applyDate(this.state.date)
    this.setState({displayDate: this.dateDisplayFormat(this.state.date)})
    this.toggleDate()
  }

  toggleDate() {
    this.setState({showDateSelection: !this.state.showDateSelection})
  }
  render() {
    let datePicker
    if(this.state.showDateSelection) {
      datePicker =  <div style={{right:15,border:'1px solid #ddd', position:'absolute', backgroundColor:'#fff', zIndex:2}}>
      <Calendar date={this.state.date}
              onChange={this.onDateChange}
            />

      </div>
    }

      return  <div> <div className="form-control input-sm" onClick={this.toggleDate}>{this.state.displayDate}</div>
        {datePicker}
        </div>
  }
}



// WEBPACK FOOTER //
// ./src/utils/calendar.js